module.exports = __webpack_public_path__ + "static/media/annotation_icon.24642b81.svg";